<template>
  <div class="col-12">
    <div class="row">
      <div class="col-sm-12 d-none d-sm-none d-md-block">
        <div class="row">
          <div class="header-menu">
            <div class="container">
              <div class="float-left">
                <ul class="nav">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="tel:0971330009">Hotline : 0971 330 009</a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      href="#">Tư vấn: 24/7</a>
                  </li>
                </ul>
              </div>
              <div class="float-right">
                <ul class="nav">
                  <li class="nav-item">
                    <router-link
                      class="nav-link active"
                      to="/login">Đăng nhập
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      to="/signup">Đăng ký
                    </router-link>
                  </li>
                  <search-input @onSearch="onSearch($event)"/>
                  <cart-icon/>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div id="menu">
            <div class="container">
              <nav class="navbar navbar-expand-md navbar-light">
                <router-link
                  class="navbar-brand"
                  to="/"><img
                  src="../../assets/images/logo.png"
                  alt="Phong thuỷ hoàng gia"
                  width="100%"
                  @error="replaceByDefault">Cố Vấn phong thủy
                </router-link>
                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapsibleNavbar">
                  <span class="navbar-toggler-icon"/>
                </button>
                <div
                  id="collapsibleNavbar"
                  class="collapse navbar-collapse">
                  <ul class="navbar-nav">
                    <li class="nav-item">
                      <router-link
                        class="nav-link"
                        to="/">
                        Trang chủ
                      </router-link>
                    </li>

                    <li class="nav-item">
                      <router-link
                        class="nav-link"
                        to="/course">
                        Khoá học
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link
                        class="nav-link"
                        :target="is_mobile ? '_self' :  '_blank'"
                        to="/services">
                        Dịch vụ
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link
                        class="nav-link"
                        :target="is_mobile ? '_self' :  '_blank'"
                        to="/items">
                        Vật phẩm
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link
                        class="nav-link"
                        to="/laso">
                        Lá số
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link
                        class="nav-link"
                        to="/posts">
                        Bài viết
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#">Chính sách</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-block d-sm-block d-md-none d-lg-none mobile-menu">
        <div
          id="mySidenav"
          class="sidenav">
          <a
            href="javascript:void(0)"
            class="closebtn"
            @click="closeMenu()">&times;</a>
          <div class="img-login">
            <center v-if="!is_login">
              <router-link
                to="/login"
                @click.native="closeMenu()">
                <img
                  src="../../assets/sesson/Ti.png"
                  alt="ảnh đại diện của tôi"
                  @error="replaceByDefault">
              </router-link>
              <router-link
                to="/login"
                @click.native="closeMenu()">Đăng nhập
              </router-link>
            </center>
            <center v-else>
              <img
                :src="base_url + current_user.avatar"
                alt="ảnh đại diện của tôi"
                @error="replaceByDefault">
              <router-link
                to="/"
                @click.native="closeMenu()">{{ current_user.full_name }}/router-link>
              </router-link>
            </center>

          </div>
          <div class="clearfix"/>
          <router-link
            to="/"
            @click.native="closeMenu()">Trang chủ
          </router-link>
          <router-link
            to="/laso"
            @click.native="closeMenu()">Lá số 2020
          </router-link>
          <router-link
            to="/laso"
            @click.native="closeMenu()">Cải vận 2021
          </router-link>
          <router-link
            to="/course"
            @click.native="closeMenu()"
          >Khóa học
          </router-link>
          <!--<router-link-->
          <!--to="/items"-->
          <!--@click.native="closeMenu()">Vật phẩm-->
          <!--</router-link>-->
          <!--<router-link-->
          <!--to="/services"-->
          <!--@click.native="closeMenu()">Dịch vụ-->
          <!--</router-link>-->
          <router-link
            v-if="is_login"
            to="/order-histories"
            @click.native="closeMenu()">Đơn hàng vật phẩm
          </router-link>
          <!--<router-link-->
          <!--to="/posts"-->
          <!--@click.native="closeMenu()">Bài viết-->
          <!--</router-link>-->
          <a
            v-if="is_login"
            @click.native="signOut()">Đăng xuất</a>
          <div class="note_service">
            <ul>
              <li>Hotline: <span>0971330009</span></li>
              <li>Email: <span>vienluanluyen@gmail.com</span></li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="menu">
            <span
              class="menu-icon"
              @click="openMenu()">&#9776;</span>
            <router-link
              to="/"
              class="menu-img"><img
              src="../../assets/images/logo.png"
              alt="Cố vấn phong thuỷ logo"
              @error="replaceByDefault">
              Cố vấn phong thủy
            </router-link>
            <cart-icon/>
          </div>
          <search-input @onSearch="onSearch($event)"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import SearchInput from '../shared/SearchInput'
  import CartIcon from '../cart/CartIcon'
  import {getCurrentUser, isLoggedIn, signOut} from '../../services/authService'
  import ApiConfig from '../../communicate/ApiConfig'
  import defaultImage from '../../assets/images/default-avatar.png'
  import mobileDetector from '../../utils/DeviceDetector'

  export default {
    name: 'Header',
    components: {
      SearchInput,
      CartIcon
    },

    data: function () {
      return {
        is_mobile: true,
        current_user: {},
        is_login: false,
        base_url: ApiConfig.base_url
      }
    },

    mounted () {
      this.is_mobile = mobileDetector()
      this.current_user = getCurrentUser()
      this.is_login = isLoggedIn()
    },

    methods: {
      onSearch (keyword) {
        this.$router.push({path: 'search', query: {keyword: keyword}})
      },
      openMenu () {
        document.getElementById('mySidenav').style.width = '250px'
        this.current_user = getCurrentUser()
        this.is_login = isLoggedIn()
      },

      closeMenu () {
        document.getElementById('mySidenav').style.width = '0'
      },
      signOut () {
        signOut()
        this.current_user = {}
        this.is_login = false
        document.getElementById('mySidenav').style.width = '0'
      },
      replaceByDefault (e) {
        e.target.src = defaultImage
      }
    }
  }
</script>
<style lang="scss" scoped>

  .sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    background-color: #fff;
    overflow-x: hidden;
    transition: 0.5s;
    padding-top: 60px;
  }

  .sidenav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 0.9rem;
    color: #818181;
    display: block;
    transition: 0.3s;
    color: #000;
  }

  .sidenav a:hover {
    background-color: #efefef;
  }

  .sidenav .closebtn {
    position: absolute;
    top: -15px;
    right: 5px;
    font-size: 36px;
    margin-left: 50px;
  }

  .sidenav .closebtn:hover {
    background: none;
  }

  .menu {
    background-color: #fff;
    height: auto;
    width: 100%;
    display: flex;
    padding: 5px 0;
  }

  .menu .menu-icon {
    width: 10%;
    font-size: 2rem;
    margin: -4px 15px;
  }

  .menu .menu-img img {
    width: 15%;
  }

  .menu .menu-img {
    width: 80%;
    text-align: justify;
    font-size: 0.9rem;
    color: #000;
    text-decoration: none;
    text-transform: uppercase;
    margin-top: 2px;
  }

  .img-login {
    width: 100%;
    margin: 0 auto;
  }

  .img-login a {
    padding-left: 8px;
  }

  .img-login img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  .note_service {
    position: absolute;
    bottom: 0;
    left: 32px;
  }

  .note_service li {
    font-size: 0.8rem;
  }

  .note_service li span {
    color: #4CAF50;
  }

  @media screen and (max-height: 450px) {
    .sidenav {
      padding-top: 15px;
    }

    .sidenav a {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue